module.exports = __webpack_public_path__ + "static/media/pe.8f0ee2a9.svg";